import { AfterViewInit, Component, ElementRef, Input, ViewChild, Output, EventEmitter} from '@angular/core';
import { Router } from '@angular/router';
import { ResponsiveScreenService } from '../../services/responsive-screen.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-help-section',
    templateUrl: './help-section.component.html',
    styleUrls: ['./help-section.component.scss'],
    standalone: true,
    imports: [NgIf, TranslateModule]
})
export class HelpSectionComponent implements AfterViewInit {
    @Input() isSubscribed: boolean = false;
    @Output() subMe = new EventEmitter()

    @ViewChild('devices') devices: ElementRef<HTMLDivElement>;
    bodyEl: HTMLBodyElement;

    constructor(public responsiveScreenService: ResponsiveScreenService, private router: Router) { }

    ngAfterViewInit(): void {
        this.updateDevicesSizeAndPosition();
        this.initResizeEvent();
    }

    private initResizeEvent(): void {
        window.addEventListener('resize', () => {
            this.updateDevicesSizeAndPosition();
        });
    }

    private updateDevicesSizeAndPosition(): void {
        if (!this.devices?.nativeElement) {
            return;
        }
        if (window.innerWidth < this.responsiveScreenService.breakpoints['HD-s'].max) {
            return;
        }
        if (!this.bodyEl) {
            this.bodyEl = document.getElementsByTagName('body')[0];
        }
        let pageZoom = parseFloat(this.bodyEl.style.getPropertyValue('--zoom'));
        if (!pageZoom) {
            pageZoom = 1;
        }

        const windowWidth = window.innerWidth;
        const refWidth = 558 * pageZoom;
        const contentWidthWithoutDevices = 1148 * pageZoom;
        const devicesWidth = Math.min(windowWidth - contentWidthWithoutDevices, refWidth);

        const ratio = devicesWidth / refWidth;
        const topRef = -144 * pageZoom;
        const top = Math.max(topRef * ratio, topRef);

        this.devices.nativeElement.style.setProperty('--computed-top', top + 'px');
        this.devices.nativeElement.style.setProperty('--computed-width', devicesWidth + 'px');
    }

    redirect() { //
      this.router.navigate(['/get-started']);
    }
}
